<template>
  <el-table
    :data="data"
    stripe
    style="width: 100%"
    size="medium"
    header-row-class-name="common-table-header"
    row-class-name="common-table-row"
    class="is-print-hide common-table"
    :border="false"
  >
    <el-table-column prop="createTime" label="导出时间">
      <template #default="{ row }">
        <span :class="{ expire: row.isExportExpire }">{{ row.createTime | formatDate }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="createTime" label="完成时间">
      <template #default="{ row }">
        <span :class="{ expire: row.isExportExpire }">{{ row.finishTime | formatDate }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="type" label="数据类型" width="180">
      <template #default="{ row }">
        <span :class="{ expire: row.isExportExpire }">{{ adaptType(row.type) }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="address" label="文件大小" width="180">
      <template #default="{ row }">
        <span :class="{ expire: row.isExportExpire }">{{ row.exportFileLength | transformFileLength }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="exportFileSuffix" label="文件格式" width="100">
      <template #default="{ row }">
        <span :class="{ expire: row.isExportExpire }">{{ row.exportFileSuffix }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="address" label="下载文件" width="200">
      <template #default="{ row: { status, isExportExpire, id, type, exportFileSuffix, progress } }">
        <span v-if="isExportExpire" class="expire">文件已过期</span>
        <a
          class="download"
          v-else-if="status === 'FINISH'"
          href="javascript:void(0)"
          @click="$emit('download', id, adaptType(type), exportFileSuffix)"
        >
          下载文件
        </a>
        <span v-else-if="status === 'FETCH'">
          {{ progress }}
        </span>
        <div v-else-if="status === 'INIT' || status === 'RUNNING'">
          <i class="el-icon-loading"></i>
          <span class="text">文件生成中</span>
          <span class="btn-cancel" @click="cancelDownload(id)">取消</span>
        </div>
        <span v-else-if="status === 'CANCEL'">文件已取消</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { MessageBox } from 'element-ui';

export default {
  name: 'downloadTable',
  props: ['data'],
  computed: {
    ...mapState('global', ['exportTypeList'])
  },
  methods: {
    cancelDownload(id) {
      MessageBox.confirm('如导出时间太久，可取消后修改导出范围重新导出。是否确认取消？', '取消导出？', {
        center: true,
        customClass: 'confirm',
        confirmButtonText: '取消导出',
        cancelButtonText: '继续等待',
        beforeClose: (action, instance, done) => {
          switch (action) {
            case 'confirm':
              done();
              this.$emit('cancel-export', id);
              break;
            case 'cancel':
            case 'close':
              done();
              break;
          }
        }
      });
    },
    adaptType(type) {
      return this.exportTypeList.find(o => o.exportType === type).exportName;
    }
  },

  filters: {
    formatDate(val) {
      if (!val) return '——';
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    transformFileLength(byte) {
      if (!byte) return '未知';
      const size = byte / (1024 * 1024);
      if (size < 0.1) {
        return (size * 1024).toFixed(2) + 'KB';
      } else {
        return size.toFixed(2) + 'MB';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.expire {
  color: #bdbdbd;
}

.download {
  color: #1e8dff;
}

.text {
  margin: 0 13px;
  color: #707070;
}

.btn-cancel {
  color: #e0514c;
  cursor: pointer;
}
</style>
